import { render, staticRenderFns } from "./RelatedDocumentStockHistoryDialog.vue?vue&type=template&id=68c080ff&"
import script from "./RelatedDocumentStockHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./RelatedDocumentStockHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports